import { SystemField } from "./system-field";

export class WarehouseLocation extends SystemField {
     
     code?:string;
     is_active?:number;
     desc?:string;
     note?:string;
     warehouses_id?:string;
     trans_types?:string;
}
